import {inject, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {catchError, map, Observable, of} from 'rxjs';
import {MessageService} from 'primeng/api';
import {AuthService} from './auth/auth.service';
import {ErrorService} from './auth/error.service';
import { AppConfigService } from 'src/config/app-config.service';
import { ModuleItem, WebManagementDto } from '../models/module.model';

@Injectable()
export class AppApiService {
  private _http = inject(HttpClient);
  private _authService = inject(AuthService);
  private _messageService = inject(MessageService);
  private _errorService = inject(ErrorService);
  apiBaseUrl: string = '';
  apiBaseUrlBizzone: string = '';
  constructor(
    private _environment: AppConfigService
  ) {
    console.log(this._environment)
    this.apiBaseUrl = this._environment.apiBase;
    this.apiBaseUrlBizzone = this._environment.apiBase;
  }

  options = {
    // headers: new HttpHeaders({
    //     Authorization: this._authService.getAuthorizationHeaderValue(),
    //     'Content-Type': 'application/json',
    // })
  };

  clientMenuGetListByUserId(query: string): Observable<any> {
    return this._http.get<any>(this.apiBaseUrl + `/api/v1/webmanager/ClientMenuGetListByUserId?` + query).pipe(this.ErrorAsync());
  }

  getWebManagements(queryParams: string): Observable<{ data?: WebManagementDto[] }> {
    return this._http.get<{ data?: WebManagementDto[] }>(`${this.apiBaseUrl}/api/v1/webmanager/GetWebManagements?` + queryParams, this.options).pipe(this.ErrorAsync());
  }

  getModules(queryParams: string): Observable<ModuleItem[]> {
    return this.getWebManagements(queryParams).pipe(
      map((res) => {
        const data = res?.data ?? [];
        return data.map((item) => this.mapDtoToModuleItem(item));
      }),
      catchError(() => of([]))
    );
  }

  private mapDtoToModuleItem(dto: WebManagementDto): ModuleItem {
    const defaultDescriptions: Record<string, string> = {
      'Quản lý Nhân sự': 'Quản lý hồ sơ nhân viên, cơ cấu tổ chức và công việc hành chính.',
      'Chấm công': 'Theo dõi và quản lý chấm công, ca làm việc.',
      'Tiền lương': 'Tính lương, bảng lương và các chính sách lương.',
      'Tài sản': 'Quản lý tài sản công ty và cấp phát.',
      'Tuyển dụng': 'Quy trình tuyển dụng và hồ sơ ứng viên.',
      'Phân quyền': 'Phân quyền truy cập và vai trò người dùng.',
      'Chi phí & Tạm ứng': 'Quản lý chi phí và tạm ứng.',
      'Hệ thống Báo cáo': 'Báo cáo tổng hợp và phân tích.',
    };
    const title = dto.webName ?? '';
    const description = dto.description ?? defaultDescriptions[title] ?? '';
    return {
      icon: dto.iconClass ?? '',
      title,
      description,
      link: dto.webUrl ?? '',
    };
  }

  setUserLanguage(queryParams: any): Observable<any> {
    return this._http.put(`${this.apiBaseUrl}/api/v1/webmanager/SetUserLanguage`, queryParams, this.options).pipe(this.ErrorAsync());
  }


  private ErrorAsync() {
    return catchError(error => {
      this.handleError(error);
      return of(error.error);
    });
  }

  private handleError(error: any) {
    this._errorService.setError(error.error);
    this._messageService.add({severity: 'error', summary: 'Error Message', detail: error.error});
  }


}
